export const light = {
  alternate: {
    light: '#fcfcfc',
    main: '#fafafb',
    dark: '#eaeaea',
  },
  cardShadow: '#b0b0b0',
  type: 'light',
  secondary: {
    main: '#93c120',
    light: '#bee759',
    dark: '#506711',
    contrastText: '#000000',
  },
  primary: {
    main: '#90caf9',
    light: 'rgb(166, 212, 250)',
    dark: 'rgb(100, 141, 174)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  info: {
    main: '#3cc8b3',
  },
  warning: {
    main: '#c8843c',
  },
  error: {
    main: '#c83c3c',
  },
  text: {
    primary: '#282828',
    secondary: '#5f5f5f',
  },
  divider: 'rgba(239,239,239,0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
    footer: '#5f7335',
  },
  drawerWidth: 240,
  topBarHeight: 60,
};

// no need to change it until is going to be used
export const dark = {
  alternate: {
    main: '#2D3748',
    dark: '#24242b',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  type: 'dark',
  primary: {
    main: '#90caf9',
    light: 'rgb(166, 212, 250)',
    dark: 'rgb(100, 141, 174)',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  secondary: {
    light: '#ffb74d',
    main: '#f9b934',
    dark: '#f57c00',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1A202C',
    default: '#121212',
    level2: '#333',
    level1: '#2D3748',
    footer: '#18181f',
  },
};
